jQuery(document).ready(function ($) {
  const allCards = document.querySelectorAll(".contact-details-box");

  function showSelectedCard(selectedValue) {
    if (!selectedValue) return;
    const selected = selectedValue.trim().toLowerCase();

    allCards.forEach((card) => {
      const cardProvince = card.dataset.province.trim().toLowerCase();

      if (cardProvince === selected) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    });
  }

  const $select = $("#province-select");

  // On Select2 change event
  $select.on("change", function () {
    showSelectedCard($(this).val());
  });

  // On page load show initial card
  showSelectedCard($select.val());
});
